import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    chartRoot: {
      width: '100%',
      height: '100vh',
      fontSize: 14,

      '& .rd3t-tree-container': {
        marginTop: 27,
      },
    },
    foreignObject: {
      overflow: 'visible',
    },
    partner: {
      fontSize: 16,
      fontWeight: 600,
      color: variables.richBlack,
    },
    branchNode: {
      height: 'inherit',
      borderRadius: 10,
      padding: 5,
      backgroundColor: '#FAFAFA',
      boxShadow: `none`,
      overflow: 'visible',
      rx: 8,
      ry: 8,
      width: 200,
      opacity: 1,
      minHeight: 103,
    },
    branchNodePartner: {
      width: 300,
    },
    line: {
      stroke: '#cfcfcf !important',
    },
    textDiv: {
      paddingTop: 16,
      display: 'block',
      paddingBottom: 9,
      lineHeight: '20px',
    },
    rectangle: {
      height: 22,
      width: 'inherit',
      borderRadius: '10px 10px 0 0',
      borderStartStartRadius: 10,
      borderEndStartRadius: 0,
      borderStartEndRadius: 10,
      borderEndEndRadius: 0,
      backgroundColor: variables.black,
      color: variables.white,
      marginTop: -4,
      marginInlineStart: -5,
      paddingInlineStart: 10,
      paddingTop: 2,
      textAlign: 'center',
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',

      '@media (max-width: 840px)': {
        fontSize: 11,
      },
    },
    rectangleIb: {
      backgroundColor: '#B385EF',
    },
    rectangleMasterIb: {
      backgroundColor: '#3BBB7A',
    },
    rectangleSubIb: {
      backgroundColor: '#37CEFF',
    },
    rectanglePrime: {
      backgroundColor: '#FFB928',
    },
    rectangleMlm: {
      backgroundColor: '#B74924',
    },
    rectangleTerminated: {
      backgroundColor: variables.black20,
    },
    partnershipContent: {
      textAlign: 'center',
      fontSize: 12,
      padding: '8px 0px',

      '@media (max-width: 840px)': {
        fontSize: 9,
      },
    },
    partnershipCode: {
      fontSize: 16,
      fontWeight: 600,
      color: variables.richBlack,
      marginBottom: 8,
    },
    partnerName: {
      fontWeight: 700,
      fontSize: 12,
      marginBottom: 8,

      '@media (max-width: 840px)': {
        fontSize: 9,
      },
    },
    clientsContent: {
      marginTop: 16,
      fontSize: 10,

      '@media (max-width: 840px)': {
        fontSize: 9,
      },
    },
    partnerClients: {
      display: 'inline-block',
      width: 76,
      height: 36,
    },
    partnerClientsValue: {
      fontSize: 18,
      fontWeight: 600,
      color: variables.richBlack,
    },
    clients: {
      display: 'inline-block',
      backgroundColor: variables.white,
      width: 76,
      height: 36,
    },
    title: {
      fontSize: 10,
      fontWeight: 500,
    },
    value: {
      fontSize: 14,
      fontWeight: 700,
      color: variables.richBlack,
      fontFamily: 'Lato',
    },
  }),
);
